import React from "react";
import { Navigate, Route } from "react-router-dom";

import { IAuthUser } from "../interfaces/IAuthUser";
import { SignIn } from "../pages/signIn/SignIn";
import { SignUp } from "../pages/signUp/SignUp";

interface AuthRoutesProps {
  user: IAuthUser | null;
}

export const AuthRoutes: React.FC<AuthRoutesProps> = ({ user }) => {
  return (
    <>
      <Route path="/" element={!user ? <SignIn /> : <Navigate to="/home" />} />
      <Route
        path="/sign-up"
        element={!user ? <SignUp /> : <Navigate to="/home" />}
      />
    </>
  );
};
